import { emptyVariantSelectorHandler } from '../../../helpers/addToCartHandler';
import { isIOS, detectIE, isSafari, isEdge } from '../../../helpers/browserHelpers';
import { ReserveCollectSearchResultStore } from '../../../types';

export function getUniqueRadioValue(store: ReserveCollectSearchResultStore, type: 'instore' | 'online'): string {
  return `${store.store.storeId}_${type}`;
}

export function checkVariantSelectionValidity(
  variantSelectorElement: Element | null,
  errorMessage: string,
  determinator = true
): Promise<void> {
  const disabledAddToCartButtonElement = document.querySelector('.add-to-cart-disabled-button');
  if (variantSelectorElement && disabledAddToCartButtonElement && determinator) {
    emptyVariantSelectorHandler(errorMessage);
    const closestElementToScrollTo = document.querySelector('.product-panel__reviews-sku-wrapper');
    if (closestElementToScrollTo && (isIOS() || detectIE() || isSafari() || isEdge())) {
      closestElementToScrollTo.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    } else {
      variantSelectorElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    }
    return Promise.reject();
  }
  return Promise.resolve();
}

export function getSelectedVariantCode(element: HTMLFormElement): string {
  const radioInputElement = Array.from(element).find((radio) => (radio as HTMLInputElement).checked);
  const variantCode = (radioInputElement as HTMLInputElement)?.value || '';
  return variantCode;
}
